import * as tslib_1 from "tslib";
import "reflect-metadata";
import { getNamespacedName, namespace } from "./namespaceUtils";
const invariant = require("invariant");
let ServiceManager = ServiceManager_1 = class ServiceManager {
    /**
     * @constructor
     */
    constructor() {
        /**
         * @type {{}}
         */
        this.container = {};
        /**
         * @type {{}}
         */
        this.providers = {};
        /**
         * @type {{}}
         */
        this.implementsList = {};
        this.bind(ServiceManager_1, this);
    }
    /**
     * @param resource
     * @param instance
     */
    bind(resource, instance) {
        this.container[this.getNameFromResource(resource)] = instance;
        return this;
    }
    /**
     * @param resource
     * @param aliasName
     * @returns {ServiceManager}
     */
    alias(resource, aliasName) {
        this.providers[this.getNameFromResource(resource)] = () => this.get(aliasName);
        return this;
    }
    /**
     * @param method
     * @param object
     * @returns {this}
     */
    bindToMethod(method, object) {
        this.implementsList[method] = object;
        return this;
    }
    /**
     * @param factory
     */
    factory(...factories) {
        factories.map(factory => factory(this));
        return this;
    }
    /**
     * @param className
     * @param callback
     * @returns {this}
     */
    provide(className, callback) {
        this.providers[this.getNameFromResource(className)] = () => {
            let instance = callback(this);
            if (!instance) {
                throw new Error(`The provider for the class "${className.name}" must provide an instance of this class when initialized.`);
            }
            this.bind(this.getNameFromResource(className), instance);
            return instance;
        };
        return this;
    }
    /**
     * @param provider
     * @returns {this}
     */
    provider(...providers) {
        providers.map(provider => {
            let realProvider = new provider();
            this.provide(realProvider.provides(), realProvider.provide.bind(realProvider));
        });
        return this;
    }
    /**
     * @param resource
     * @returns {any}
     */
    get(resource) {
        if (!resource) {
            return Object.assign({}, this.container);
        }
        if (this.container[this.getNameFromResource(resource)]) {
            return this.container[this.getNameFromResource(resource)];
        }
        if (this.providers[this.getNameFromResource(resource)]) {
            return this.providers[this.getNameFromResource(resource)](this);
        }
        let result = this.instantiate(resource);
        invariant(result, `Could not "get" ${this.getNameFromResource(resource)}`);
        this.bind(resource, result);
        return result;
    }
    /**
     * @param resource
     */
    instantiate(resource) {
        const args = Reflect.getMetadata('design:paramtypes', resource) || [];
        const dependencies = [];
        try {
            args.forEach(arg => dependencies.push(this.get(arg)));
        }
        catch (error) {
            console.warn(`Could not get constructor dependencies for ${resource.name}. Please check the bellow error for more details.`);
            throw error;
        }
        const instance = new resource(...dependencies);
        Object.keys(this.implementsList).forEach(key => {
            if (key in instance) {
                instance[key](this.get(this.implementsList[key]));
            }
            else {
                for (var item in instance) {
                    if (key === item) {
                        instance[key](this.get(this.implementsList[key]));
                    }
                }
            }
        });
        return instance;
    }
    /**
     * @param resource
     * @returns {string}
     */
    getNameFromResource(resource) {
        if (typeof resource === "string") {
            return resource;
        }
        return getNamespacedName(resource);
    }
};
ServiceManager = ServiceManager_1 = tslib_1.__decorate([
    namespace('Stejar/Core'),
    tslib_1.__metadata("design:paramtypes", [])
], ServiceManager);
export { ServiceManager };
var ServiceManager_1;
